import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { OrderPipe } from 'ngx-order-pipe';
import { PdfpopupComponent } from 'src/app/shared/models/pdfpopup/pdfpopup.component';

import { MainserviceService } from 'src/app/shared/service/mainservice.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-archivedtable',
  templateUrl: './archivedtable.component.html',
  styleUrls: ['./archivedtable.component.scss']
})
export class ArchivedtableComponent implements OnInit {

  
 count=0;

  posturl: string ="assets/pdf/";
 
//  src = "assets/dummy (1).pdf";
  constructor(public dialog: MatDialog,private MainserviceService: MainserviceService,
  private HttpClient:HttpClient,private httpService: HttpClient) { }

  archiveddata:any;
  lcaNo:null;
  ngOnInit() {
    
    window.scrollTo(0, 0);
    if((this.MainserviceService.lcaNumberA != "0" && this.MainserviceService.lcaNumberA != "") && (this.MainserviceService.postDateA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == "" && this.MainserviceService.lcaRoleA ==""))
    {
      this.getpostingdataA1(this.MainserviceService.lcaNumberA);
    }
    else if((this.MainserviceService.postDateA != "" && this.MainserviceService.postDateA !="Invalid date") && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == "" && this.MainserviceService.lcaRoleA ==""))
    {
      this.getpostingdataA2(this.MainserviceService.postDateA);
    }    
    else if((this.MainserviceService.stateA != "" && this.MainserviceService.stateA != null) && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.postDateA =="" && this.MainserviceService.cityA == "" && this.MainserviceService.lcaRoleA ==""))
    {
      this.getpostingdataA3(this.MainserviceService.stateA);
    }    
    else if((this.MainserviceService.stateA != ""  && this.MainserviceService.cityA != "" ) && (this.MainserviceService.lcaNumberA == "" && this.MainserviceService.postDateA =="" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.lcaRoleA == ""))
    {
      this.getpostingdataA4(this.MainserviceService.stateA, this.MainserviceService.cityA);
    }
    else if(this.MainserviceService.lcaRoleA != "" && (this.MainserviceService.lcaNumberA =="" && this.MainserviceService.postDateA == "" && this.MainserviceService.lcaYearA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == ""))
    {
      this.getpostingdataA5(this.MainserviceService.lcaRoleA);
    }
    else if(this.MainserviceService.lcaYearA != "" && (this.MainserviceService.lcaNumberA =="" && this.MainserviceService.postDateA == "" && this.MainserviceService.lcaRoleA == "" && this.MainserviceService.stateA =="" && this.MainserviceService.cityA == ""))
    {
      this.getpostingdataA6(this.MainserviceService.lcaYearA);
    }   
    else if(this.MainserviceService.lcaNumberA !="" && this.MainserviceService.postDateA != "" && this.MainserviceService.lcaRoleA != "" && this.MainserviceService.stateA !="" && this.MainserviceService.cityA != "" && this.MainserviceService.lcaYearA != "")
    {
      this.getpostingdataA7(this.MainserviceService.lcaNumberA,this.MainserviceService.postDateA,this.MainserviceService.lcaYearA,this.MainserviceService.stateA,this.MainserviceService.cityA,this.MainserviceService.lcaRoleA);
    }      
    else
    {
      this.getpostingdataA();
    }
    //this.getpostingdataA();    
  }

  getpostingdataA()
  {
  //this.httpService.get('./assets/api/state.json').subscribe(
        this.MainserviceService.getarchivedata().subscribe(
      data => {
        this.archiveddata = data as string [];	 
       
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );
  }

  filteredlca: any;
  getpostingdataA1(lcano)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcano!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCANumber==lcano){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdataA2(postDate)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(postDate!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].PostedOnDate==postDate){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA3(state)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA4(state,city)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].stateId==state && this.filteredlca[i].city==city){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }  

  getpostingdataA5(role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(role!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdataA6(lcayear)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(lcayear!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCAYear==lcayear){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  }

  getpostingdataA7(lcano,postdt,lcayear,state,city,role)
  {
    this.MainserviceService.getarchivedata().subscribe(     
      data => {
        this.filteredlca = data as string [];	 
        this.archiveddata=[];    
          var len=this.filteredlca.length;
            if(state!=""){
            for (let i = 0; i < len; i++) {
              if(this.filteredlca[i].LCANumber==lcano && this.filteredlca[i].PostedOnDate==postdt && this.filteredlca[i].LCAYear==lcayear && this.filteredlca[i].stateId==state && this.filteredlca[i].city==city && this.filteredlca[i].LCARoleId==role){
              let obj = {
                LCANumber:this.filteredlca[i].LCANumber,
                state:this.filteredlca[i].state,
                city:this.filteredlca[i].city,
                LCAPosition:this.filteredlca[i].LCAPosition,
                LCAStartDate:this.filteredlca[i].LCAStartDate,
                LCAEndDate:this.filteredlca[i].LCAEndDate,
                PostedOnDate:this.filteredlca[i].PostedOnDate,
                PostingNotice:this.filteredlca[i].PostingNotice
              };
              this.archiveddata.push(obj);
            }
          }   
        }
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );    
  } 



visa=[
  {
first:'11-2-2020',
two:'1234567',
three:'Texas',
four:'Austin',
five:'Lead Engineer',
six:'13-07-2020',
seven:'13-07-2023',
eighteen:'TA - Texas Lead Engine…',


},
{
  first:'12-2-2020',
  two:'1234567',
  three:'Texas',
  four:'Austin',
  five:'Lead Engineer',
  six:'13-07-2020',
  seven:'13-07-2023',
  eighteen:'TA - Texas Lead Engine…',
  
  },
  {
    first:'16-07-2020',
    two:'1234567',
    three:'Texas',
    four:'Austin',
    five:'Lead Engineer',
    six:'13-07-2020',
    seven:'13-07-2020',
    eighteen:'TA - Texas Lead Engine…',
    
    },
    {
      first:'17-07-2020',
      two:'1234567',
      three:'Texas',
      four:'Austin',
      five:'Lead Engineer',
      six:'13-07-2020',
      seven:'13-07-2020',
      eighteen:'TA - Texas Lead Engine…',
      
      },
      {
        first:'18-07-2020',
        two:'1234567',
        three:'Texas',
        four:'Austin',
        five:'Lead Engineer',
        six:'13-07-2020',
        seven:'13-07-2023',
        eighteen:'TA - Texas Lead Engine…',
        
        },
        {
          first:'19-07-2020',
          two:'1234567',
          three:'Texas',
          four:'Austin',
          five:'Lead Engineer',
          six:'13-07-2020',
          seven:'13-07-2023',
          eighteen:'TA - Texas Lead Engine…',
          
          },
          {
            first:'6-07-2020',
            two:'1234567',
            three:'Texas',
            four:'Austin',
            five:'Lead Engineer',
            six:'13-07-2020',
            seven:'13-07-2023',
            eighteen:'TA - Texas Lead Engine…',
            
           
            },
            {
              first:'1-07-2020',
              two:'1234567',
              three:'Texas',
              four:'Austin',
              five:'Lead Engineer',
              six:'13-07-2023',
              seven:'13-07-2023',
              
              eighteen:'TA - Texas Lead Engine…',
              },
              {
                first:'16-08-2020',
                two:'1234567',
                three:'Texas',
                four:'Austin',
                five:'Lead Engineer',
                six:'13-07-2020',
                seven:'13-07-2023',
                eighteen:'TA - Texas Lead Engine…',
                
                
                },
                {
                  first:'16-07-2020',
                  two:'1234567',
                  three:'Texas',
                  four:'Austin',
                  five:'Lead Engineer',
                  six:'13-07-2020',
                  seven:'13-07-2023',
                  eighteen:'TA - Texas Lead Engine…',
                  
                  },

]


order: string = 'title';
reverse: boolean = false;
setOrder(value: string) {
  if (this.order === value) {
    this.reverse = !this.reverse;
  }
  this.order = value;
}


count1(){

if(this.count==0){
  this.count=1;
return this.visa.sort((a,b)=>{
  return <any>new Date(b.first)- <any>new Date(a.first);
 
});
}
if(this.count==1){
  this.count=0;
return this.visa.sort((a,b)=>{
  return <any>new Date(a.first)- <any>new Date(b.first);
  
});
}
}
name: any;
animal: any;

// pdfpoppopup():void {
//   const dialogRef = this.dialog.open(PdfpopupComponent, {
 
//     // data: {name: this.name, animal: this.animal}
//   });

//   dialogRef.afterClosed().subscribe(result => {
//     console.log('The dialog was closed');
//     this.animal = result;
//   });
// }
// pdfarray=[{
//   pdf1:'/assets/HTML 4 for Dummies, 4th Edition.pdf',
//   pdf2:'assets/dummy (1).pdf'
// }]
pdfpoppopup(url){
  const data=" https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";

  window.open(url,"_blank");
}


}
